import script from "./TemplateOne.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateOne.vue?vue&type=script&setup=true&lang=js"

import "./TemplateOne.vue?vue&type=style&index=0&id=1c0cdec0&lang=css"

const __exports__ = script;

export default __exports__